var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBoldDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29838 2.66984L4.21213 5.58359C4.65088 6.02234 5.35963 6.02234 5.79838 5.58359L8.71213 2.66984C9.42088 1.96109 8.91463 0.746094 7.91338 0.746094L2.08588 0.746094C1.08463 0.746094 0.589631 1.96109 1.29838 2.66984Z",
    fill: "#1A9CC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoldDown);
export default __webpack_public_path__ + "static/media/icon-bold-down.d9c8a064973623f04105265c794a6884.svg";
export { ForwardRef as ReactComponent };